export const product_Loading_status = "product_Loading_status";

export const product_Error_status = "product_Error_status";

export const product_Success_status = "product_Success_status";

export const product_Add_Success_status = "product_Add_Success_status";

export const product_Update_Success_status = "product_Update_Success_status";

export const product_Delete_Success_status = "product_Delete_Success_status";
